<template>
  <div class="admin-add-territory">
    <error :err.sync="error" />
    <form-generator
      :elements="elements"
      :data="territory || {}"
      :handleUpdate="({ key }, v) => (territory[key] = v)"
    />
  </div>
</template>

<script>
import territorySchema from "@/validation-schemas/territory";
import FormGenerator from "@/components/form-generator.vue";
import { mapState } from "vuex";

export default {
  components: { FormGenerator },
  props: {
    territory: Object
  },
  name: "admin-add-territory",
  data() {
    return {
      error: null,
      loading: false
    };
  },
  computed: {
    ...mapState("ancillaries", { territories: "bookCategories" }),
    elements() {
      return [
        {
          key: "name",
          label: "name",
          type: "string"
        },
        {
          key: "code",
          label: "code",
          type: "string"
        },
        {
          text: "save",
          type: "button",
          className: "float-right mt-5 mt-sm-0",
          attrs: {
            loading: this.loading,
            block: this.isSmallScreen
          },
          events: {
            click: this.add
          }
        }
      ];
    }
  },
  methods: {
    async add() {
      this.error = null;
      const { territory } = this;
      const validation = territorySchema.validate(territory, this.joiOptions);
      if (validation.error) {
        this.error = validation.error.message;
      } else {
        this.loading = true;
        try {
          const res = await this.$store.dispatch("territories/update", {
            ...territory,
            parent_territory_id: territory.parent_territory_id
              ? territory.parent_territory_id.id
              : null
          });
          this.$emit("added", res.data);
        } catch (err) {
          console.error(err);
        }
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
